import React, { useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'

import IntegrationsSettings from '@/views/Integrations/IntegrationsSettings'
import IntegrationsMonitoring from '@/views/Integrations/IntegrationsMonitoring'
import IntegrationsLogs from '@/views/Integrations/IntegrationsLogs'
import { ButtonAndFormModal } from '@/components/layout/modals/ButtonAndFormModal'
import { Card } from '@/components/cards/Card'
import { Breadcrumbs } from '@/components/forms/Breadcrumbs/Breadcrumbs'
import {
  activateIntegration,
  fetchIntegration,
  resetHealthScore,
} from '@/reducers/integrations/integrations.actions'
import { ModalActions } from '@/components/modals/ModalActions'

import './integrations.css'

// redux information is dispatched from the Wrapper for both section and config editor
export const IntegrationEditor = () => {
  const dispatch = useDispatch()
  const { integration, activating, dirty, healthScore } = useSelector((state) => state.integrations)
  const { integration_config_id } = useParams()

  useEffect(() => {
    dispatch(fetchIntegration(integration_config_id))
  }, [])

  const backLinks = {
    label: 'Integrations',
    link: '/integrations',
  }

  const handleActivate = () => {
    dispatch(
      activateIntegration({
        id: integration.id,
        values: { ...integration, active: !integration?.active },
      })
    )
  }

  const handleResetHealthScore = () => {
    dispatch(resetHealthScore(integration))
  }

  return (
    <div className="integration-editor-content" data-testid="integration-editor">
      <div className="page-header">
        <Breadcrumbs backLinks={backLinks} currentLink={integration?.name} />
        <div className="flex-align-center gap">
          <ButtonAndFormModal
            buttonLabel={integration.active ? 'Deactivate' : 'Activate'}
            modalTitle="Change Integration Activation"
            modalId="integrations/activate"
            modalProps={{ size: 'tiny' }}
            buttonProps={{ loading: activating }}
            disabled={dirty}
            form={
              <ModalActions
                onSubmit={handleActivate}
                buttonLabel={integration?.active ? 'Deactivate' : 'Activate'}
              >
                <p>
                  {`Are you sure you want to ${integration?.active ? 'deactivate' : 'activate'} this integration?`}
                </p>
              </ModalActions>
            }
          />

          <ButtonAndFormModal
            buttonLabel="Reset HealthScore"
            modalTitle="Reset Integration HealthScore"
            modalId="integrations/reset_healthscore"
            modalProps={{ size: 'tiny' }}
            buttonProps={{ loading: healthScore }}
            disabled={dirty}
            form={
              <ModalActions onSubmit={handleResetHealthScore} buttonLabel="Reset HealthScore">
                <p>Are you sure you want to reset the healthscore for this integration?</p>
              </ModalActions>
            }
          />
        </div>
        {/* primary because we don't have the other button yet */}
      </div>
      <Card>
        <IntegrationsMonitoring />
        <IntegrationsSettings />
        <IntegrationsLogs />
      </Card>
    </div>
  )
}

export default IntegrationEditor
